import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { varHover } from 'src/components/animate';
import useNotificationService from 'src/services/notifications-service';
import NotificationItem from './notification-item';

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const drawer = useBoolean();
  const smUp = useResponsive('up', 'sm');

  const { user } = useAuthContext();
  const { notifications, clearNotifications, markNotificationAsRead } = useNotificationService(
    user?.id
  );
  const totalUnRead = notifications.filter((item) => item.read !== true).length;

  //   const notifications = unknown.map((value, index) => ({
  //     id: index,
  //     type: 'payment',
  //     category: 'Order',
  //     isUnRead: true,
  //     createdAt: value.date,
  //     amount: value.amount,
  //     title: value?.merchant_name ?? value.name ?? '',
  //     transaction: value,

  const handleMarkAllAsRead = async () => {
    await clearNotifications(user?.id);
  };

  const renderHead = (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Notifications
      </Typography>

      {!!totalUnRead && (
        <Tooltip title="Mark all as read">
          <IconButton color="primary" onClick={() => handleMarkAllAsRead()}>
            <Iconify icon="eva:done-all-fill" />
          </IconButton>
        </Tooltip>
      )}

      {!smUp && (
        <IconButton onClick={drawer.onFalse}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      )}
    </Stack>
  );

  const renderList = (
    <Scrollbar>
      <List disablePadding>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClick={() => markNotificationAsRead(notification)}
          />
        ))}
      </List>
    </Scrollbar>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        color={drawer.value ? 'primary' : 'default'}
        onClick={drawer.onTrue}
      >
        <Badge
          variant="dot"
          badgeContent={totalUnRead !== 0 && `${totalUnRead}${totalUnRead >= 10 ? '+' : ''}`}
          color={totalUnRead > 0 ? 'error' : 'default'}
          children={<Iconify icon="solar:bell-bing-bold-duotone" width={24} />}
        />
      </IconButton>

      <Drawer
        sx={{ zIndex: 9999 }}
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 1, maxWidth: 420 },
        }}
      >
        {renderHead}

        <Divider />

        {renderList}

        <Box sx={{ p: 1 }}>
          <Button fullWidth size="large" onClick={handleMarkAllAsRead}>
            View All
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
